<div class="popup-container">

<header>
  <label class="close_button" (click)="close()">x</label>
  <div class="header d-block roboto-medium">
    <label class="ms-3 mt-3 mb-3">{{heading}}</label>
  </div>
</header>

<div class="body">
  <label class="catlabel m-3"> {{description}}</label>
</div>

<div class="footer d-flex justify-content-end align-items-center fixed-bottom mt-5 pt-2 pb-2">
  <button class="cancel me-3 roboto-bold" (click)="close()"> CANCEL </button>
  <button class="submit black-button me-3 roboto-bold" (click)="saveClick()">{{dataStore?.event}}</button>
</div>
</div>